export const transformCourseCityDates = (data, stringify = false) => {
  data.dates.forEach((item) => {
    for (const iKey in item) {
      if (iKey === 'teachingTimes') {
        if (item[iKey].length > 0) {
          item[iKey] = item[iKey].map((t) => t.time);
        } else {
          item[iKey] = [];
        }
      } else {
        if (item[iKey] === '' || typeof item[iKey] === 'undefined') {
          item[iKey] = null;
        }
      }

      if (iKey === 'price' || iKey === 'additionalCosts') {
        if (item[iKey]) {
          let value = item[iKey];
          value = value && typeof value !== 'string' ? value.toString() : value;

          if (typeof value === 'string' && value.includes(',')) {
            value = value.replace(',', '.');
          }

          item[iKey] = value;
        }
      }

      if (iKey === 'dateType') {
        if (item[iKey]) {
          let dateType = item[iKey];

          console.log('item[iKey]', item[iKey]);

          item['guaranteedDate'] = item[iKey].guaranteedDate;
          item['expectedDate'] = item[iKey].expectedDate;
          item['planedDate'] = item[iKey].planedDate;
        }
      }
    }
  });

  return stringify ? JSON.stringify(data) : data;
};
